import { BrowserViewportFactory } from 'pf-frontend-common/src/module/browser/viewport.factory';
import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { StatsAttributionService } from 'pf-frontend-common/src/service/stats-attribution/service';
import { StatsDataService } from 'pf-frontend-common/src/service/stats-data/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { AgentStatsDataAdapterFactory } from 'common/data/agent/stats/data-adapter.factory';
import { AgentListCommonViewStore } from 'common/module/agent/list-common/view-store';
import { StatsService } from 'common/service/stats/service';
import { AgentListCommonStrategyFactory } from 'desktop/module/agent/list-common/strategy.factory';
import { LeadEmailFormAgentFactory } from 'desktop/module/lead/email/form/agent.factory';

// TODO-FE[WEB-1602]: Rename the parent directory and change name to AgentListViewStoreFactory
export function AgentListCommonViewStoreFactory(): AgentListCommonViewStore {
  const agentListViewStore = new AgentListCommonViewStore(
    EventEmitterFactory(),
    WindowService(),
    LeadEmailFormAgentFactory(),
    StatsService(),
    StatsDataService(),
    StatsAttributionService(),
    AgentStatsDataAdapterFactory(),
    BrowserViewportFactory()
  );

  agentListViewStore.setStrategy(AgentListCommonStrategyFactory());

  return agentListViewStore;
}
